import React from "react";
import BannerImg from "../../../asstes/hash_banner_bg.png";
import UserImg from "../../../asstes/user-img.png";
import { useSelector } from "react-redux";
import { IKImage, IKContext, IKUpload } from "imagekitio-react";

const TopBanner = () => {
  const { user } = useSelector((state) => state.user);
  return (
    <div
      className="topbanner_wrapper"
      style={{ backgroundImage: `url(${BannerImg})` }}
    >
      <div className="topbanner_inner">
        <div className="topbanner_image">
          <IKContext
            publicKey="public_EO86IPkjdNBiFNTw23MRYxLJVSY="
            urlEndpoint="https://ik.imagekit.io/hashfinder"
            transformationPosition="path"
            authenticationEndpoint="http://localhost:5000/auth"
          >
            {user?.profile_picture ? (
              <img
                src={user.profile_picture}
                alt={user?.name}
                className="profile_banner_img"
              />
            ) : (
              <img
                src={UserImg}
                alt={user?.name}
                className="profile_banner_img"
              />
            )}
            <IKUpload fileName="my-upload" className="upload_pic" />
          </IKContext>
        </div>
        <div className="topbanner_content">
          <h2 className="topbanner_name">{user?.name}</h2>
        </div>
      </div>
    </div>
  );
};

export default TopBanner;
